import React from 'react';
import { Helmet } from 'react-helmet';
import Icon from '../../components/AppIcon';
import SocialRegistration from './components/SocialRegistration';
import RegistrationForm from './components/RegistrationForm';
import ValueProposition from './components/ValueProposition';
import LoginRedirect from './components/LoginRedirect';

const UserRegistration = () => {
  return (
    <>
      <Helmet>
        <title>Create Account - RealRoll | Professional Film Credit Generation</title>
        <meta name="description" content="Join RealRoll to create professional film credits with industry-standard templates, Excel import, and HD video export capabilities." />
      </Helmet>
      <div className="min-h-screen bg-background">
        {/* Header */}
        <header className="bg-card border-b border-border">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex items-center justify-between h-16">
              <div className="flex items-center space-x-2">
                <div className="w-8 h-8 bg-primary rounded-lg flex items-center justify-center">
                  <Icon name="Film" size={20} color="white" />
                </div>
                <span className="text-xl font-bold text-primary font-sans">RealRoll</span>
              </div>
              <div className="text-sm text-muted-foreground">
                Professional Film Credit Generation
              </div>
            </div>
          </div>
        </header>

        {/* Main Content */}
        <main className="flex-1">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 lg:py-12">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-start">
              
              {/* Registration Form Section */}
              <div className="order-2 lg:order-1">
                <div className="max-w-md mx-auto lg:mx-0">
                  {/* Form Header */}
                  <div className="text-center lg:text-left mb-8">
                    <h1 className="text-3xl font-bold text-foreground mb-2">
                      Create Your Account
                    </h1>
                    <p className="text-muted-foreground">
                      Start creating professional film credits in minutes
                    </p>
                  </div>

                  {/* Social Registration */}
                  <SocialRegistration />

                  {/* Registration Form */}
                  <RegistrationForm />

                  {/* Login Redirect */}
                  <LoginRedirect />
                </div>
              </div>

              {/* Value Proposition Section */}
              <div className="order-1 lg:order-2">
                <div className="sticky top-8">
                  <ValueProposition />
                </div>
              </div>
            </div>
          </div>
        </main>

        {/* Footer */}
        <footer className="bg-card border-t border-border mt-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
            <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
              <div className="md:col-span-2">
                <div className="flex items-center space-x-2 mb-4">
                  <div className="w-6 h-6 bg-primary rounded flex items-center justify-center">
                    <Icon name="Film" size={14} color="white" />
                  </div>
                  <span className="font-semibold text-foreground">RealRoll</span>
                </div>
                <p className="text-sm text-muted-foreground mb-4">
                  Professional film credit generation platform trusted by filmmakers worldwide.
                </p>
                <div className="flex items-center space-x-4">
                  <div className="flex items-center space-x-1 text-xs text-muted-foreground">
                    <Icon name="Shield" size={12} />
                    <span>SSL Secured</span>
                  </div>
                  <div className="flex items-center space-x-1 text-xs text-muted-foreground">
                    <Icon name="Lock" size={12} />
                    <span>Privacy Protected</span>
                  </div>
                </div>
              </div>

              <div>
                <h4 className="font-medium text-foreground mb-3">Product</h4>
                <ul className="space-y-2 text-sm text-muted-foreground">
                  <li>Features</li>
                  <li>Templates</li>
                  <li>Pricing</li>
                  <li>API</li>
                </ul>
              </div>

              <div>
                <h4 className="font-medium text-foreground mb-3">Support</h4>
                <ul className="space-y-2 text-sm text-muted-foreground">
                  <li>Help Center</li>
                  <li>Contact Us</li>
                  <li>Status</li>
                  <li>Community</li>
                </ul>
              </div>
            </div>

            <div className="border-t border-border mt-8 pt-6 flex flex-col sm:flex-row justify-between items-center">
              <p className="text-xs text-muted-foreground">
                © {new Date()?.getFullYear()} RealRoll. All rights reserved.
              </p>
              <div className="flex items-center space-x-4 mt-4 sm:mt-0">
                <span className="text-xs text-muted-foreground">Terms</span>
                <span className="text-xs text-muted-foreground">Privacy</span>
                <span className="text-xs text-muted-foreground">Cookies</span>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default UserRegistration;